module.exports = __webpack_public_path__ + "static/media/short-url.37b3eb37.png";